import i18next from 'i18next';
import * as React from 'react';
import { StandardLocalWidget, any, fromJSX } from "widgets-for-react";
import { paymentMethodWidget } from "../../forms/paymentMethod/paymentMethodWidget";
import { TextPageHeader } from '../../site/root/pageHeader/pageHeaderLayout';
import { RootLayout } from '../../site/root/rootLayout';
import { SubscriptionLayout } from "../subscriptionLayout";
import { SubscriptionState, subscriptionUpdaters } from "../subscriptionState";
import { changePaymentMethodUpdaters } from "./changePaymentMethodState";
import { initializePIIData, PIIData } from 'utils/datalayer';

export const changePaymentMethodWidget: StandardLocalWidget<SubscriptionState> = currentState =>
  any([
    currentState.changePaymentMethodInput.changePaymentMethod.kind == "loaded" ?
      fromJSX(() =>
        currentState.changePaymentMethodInput.changePaymentMethod.kind == "loaded" ?
          currentState.changePaymentMethodInput.changePaymentMethod.value.Kind == "Redirect" ?
            <SubscriptionLayout.RedirectToPsp
              variant="other"
              redirectUrl={currentState.changePaymentMethodInput.changePaymentMethod.value.RedirectUrl}
            />
            : currentState.changePaymentMethodInput.changePaymentMethod.value.Kind == "Success" ?
              <SubscriptionLayout.ThankYou
                variant="change-payment-method-success"
                subscriptionState={currentState}
              />
              : <SubscriptionLayout.FailureOrCancel
                variant="change-payment-method-failure"
              />
          : <></>
      )
      :
      fromJSX(setState =>
        {
          const piiData = initializePIIData(currentState.userSubscriptions);

          return (<div className="text-screen">
          <TextPageHeader
            title={i18next.t('subscription:ChangePaymentMethodTitle')}
            intro={i18next.t('subscription:ChangePaymentMethodValidationIntro')}
            breadcrumbs={undefined}
          />
          <section className="block block--text">
            <div className="block__inner container--m gutter--m">
              <div className="block__content">
                <div className="block__text">
                  {currentState.lookupData.kind == "loaded" ?
                    paymentMethodWidget(currentState.lookupData.value.IDealIssuers, piiData)(currentState.changePaymentMethodInput.paymentMethodState)
                      .map(changePaymentMethodUpdaters.paymentMethodState)
                      .map(subscriptionUpdaters.changePaymentMethodInput)
                      .run(setState)
                    : <RootLayout.Loader hasWrapper showText />
                  }

                  <SubscriptionLayout.ActionAndBackButtons
                    back={() => setState(subscriptionUpdaters.overview)}
                    action={() => setState(subscriptionUpdaters.invokeChangePaymentMethodApi)}
                    actionText={i18next.t("subscription:ChangePaymentMethod")}
                    actionDisabled={!currentState.changePaymentMethodInput.isValid()}
                  />
                </div>
              </div>
            </div>
          </section>
        </div>
        )}
      )
  ])
